<template>
  <div class="CallIn--overlay absolute">
    <div class="CallIn--modal">
      <div v-show="!connected" class="CallIn--container">
        <div class="CallIn--header">
          視像通話請求
        </div>
        <div class="CallIn--center">
          <div>通話來自</div>
          <div class="CallIn--location" v-html="callInLocation"></div>
        </div>
        <div class="CallIn--bottom">
          <v-btn
            fab
            dark
            class="accept-btn"
            @click="emitEvent('accept')"
          >
            <v-icon>phone</v-icon>
          </v-btn>

          <v-btn
            fab
            dark
            class="reject-btn"
            @click="emitEvent('reject')"
          >
            <v-icon>mdi-phone-hangup</v-icon>
          </v-btn>
        </div>
      </div>
      <div v-show="connected" class="CallIn--video-container">
        <div class="relative">
          <video ref="remoteVideoPlayer" width="960" height="720" autoplay></video>
          <div class="CallIn--local-video absolute">
            <video ref="localVideoPlayer" autoplay></video>
          </div>
        </div>
        <div class="CallIn--bottom">
          <v-btn
            fab
            dark
            class="switch-btn"
            @click="emitEvent('videoOnOff')"
          >
            <v-icon>mdi-video-off</v-icon>
          </v-btn>

          <v-btn
            fab
            dark
            class="disconnect-btn"
            @click="emitEvent('stopStream')"
          >
            <v-icon>mdi-phone-hangup</v-icon>
          </v-btn>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  // import locationService from '@/services/logistics/location'
  import { mapState } from 'vuex'

  export default {
    props: {
      caller: {
        type: Object,
        required: true,
      },
    },

    computed: {
      ...mapState('videoCall', [
        'localStream',
        'remoteStream',
        'connected',
      ]),

      callInLocation () {
        return process.env.CALL_IN_LOCATION || ''
      }
    },

    methods: {
      emitEvent (event, params = null) {
        this.$emit(event, params)
      },
    },

    watch: {
      connected (val) {
        if (!val) return
        this.$refs.localVideoPlayer.srcObject = this.localStream
        this.$refs.remoteVideoPlayer.srcObject = this.remoteStream
      }
    }
  }
</script>

<style lang="stylus" scoped>
  .CallIn
    &--overlay
      background: rgba(black, 0.5)
      height: 100%
      width: 100%
      top: 0
      left: 0
      z-index: 10
    &--modal
      display: flex
      justify-content: center
      align-items: center
      height: 100%
      width: 100%
    &--container
      background: white
      border-radius: 30px
      padding: 6.5em 2.12em
      text-align: center
    &--header
      color: #31578D
      font-size: 3rem
      margin-bottom: 5.37rem
    &--center
      font-size: 1.85rem
      color: #868686
    &--location
      font-size: 5rem
      color: black
      line-height: 6rem
      margin-bottom: 7rem
    &--bottom
      display: flex
      justify-content: space-around
      .accept-btn
        background-color: #3FDB18 !important
        width: 200px
        height: 200px
        i
          font-size: 6rem
      .reject-btn
        background-color: #FF0000 !important
        width: 200px
        height: 200px
        i
          font-size: 6rem
      .switch-btn
        background-color: #31578D !important
      .disconnect-btn
        background-color: #FF0000 !important
    &--video-container
      background: white
      border-radius: 30px
      padding: 2.5em 2.12em
      text-align: center
    &--local-video
      bottom: 0
      right: 0
      z-index: 1
      width: 12em
      height: 10em
      video
        width: 100%
        height: 100%
</style>



// WEBPACK FOOTER //
// src/components/Common/CallIn.vue